export default "__VITE_ASSET__DPiI4K$E__"